import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { CategoryService } from 'src/app/api/catalog/category.service';
import { map } from 'rxjs';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
import * as moment from 'moment';
import { SearchClientComponent } from 'src/app/components/search-client/search-client.component';
import { ClientExtendsComponent } from 'src/app/sale/client/client-extends/client-extends.component';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { SearchTourComponent } from 'src/app/components/search-tour/search-tour.component';
import { SearchEmployeeComponent } from 'src/app/components/search-employee/search-employee.component';
import { SearchPackagetourComponent } from 'src/app/components/search-packagetour/search-packagetour.component';
import SwalAlert from 'src/app/utils/swalalert';
import { PackagetourService } from 'src/app/api/tourism/packagetour.service';
import { HttpHeaders } from '@angular/common/http';
import { AirlineService } from 'src/app/api/flight/airline.service';
import { BookingflightsService } from 'src/app/api/flight/bookingflights.service';
declare var $: any;

@Component({
  selector: 'app-bookingflights-form',
  templateUrl: './bookingflights-form.component.html',
  styleUrls: ['./bookingflights-form.component.css']
})
export class BookingflightsFormComponent implements OnInit, AfterViewInit {
  @ViewChild(SearchClientComponent) SearchClientComponent: any;
  @ViewChild(SearchEmployeeComponent) SearchEmployeeComponent: any;
  @ViewChild(ClientExtendsComponent) ClientExtendsComponent: any;

  private thisComponent: BookingflightsFormComponent;
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  isLoadEdit: boolean = false;

  isClientSelected: boolean = false;
  clientSelected: any = {};
  employeeSelected: any = null;
  packagetourSelected: any = null;
  view_itinerary: boolean = false;

  //init variables
  originsbooking: any = [];
  arrivalplaces: any = [];
  airlines: any = [];
  showSectionFlight = false;

  // array variables
  section_flights: any = [];

  // prev_sections_flight
  airlineSelected: any = null;
  airlineSelectedData: any = null;
  airportDeparture: any = null;
  dateDeparture: any = null;
  timeDeparture: any = null;
  airportArrival: any = null;
  dateArrival: any = null;
  timeArrival: any = null;
  number_flight: any = null;

  // saldo pendiente
  difference_balance: number = 0;

  // fortmat pdf
  selectedPdfFileFlight: any | null = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private globalService: GlobalService,
    private airlineService: AirlineService,
    private generalService: GeneralService,
    private bookingflights: BookingflightsService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.thisComponent = this;

    this.item = this.fb.group({
      client_id: [null, [Validators.required]],
      bookingorigin_id: [1, [Validators.required]],
      employee_id: [null],
      typetransport_id: [null],
      typebooking_id: [null],
      currency_id: [null],
      tel_1: [null, [Validators.required]],
      tel_2: [null],
      code_flight: [null],
      nro_passengers: [null],
      date_booking: [null],
      observations: [null],
      // totales
      total: [0],
      total_paid: [0],
      text_amount: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.getOriginBooking();
    this.getAirlines();

    if (this.isEdit) {
      this.editData();
    } else {
      this.generateCalendarDateArrival();
    }
    // setTimeout(() => {
    // }, 150);
    this.navigationTrackerService.initializeMenu(this.route);
  }

  editData() {
    this.bookingflights.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.item;
        this.item.patchValue({
          client_id: item_.client_id,
          bookingorigin_id: item_.bookingorigin_id,
          code_flight: item_.code_flight,
          nro_passengers: item_.nro_passengers,
          date_booking: item_.date_booking,
          observations: item_.observations,
          //=====
          total: item_.total,
          total_paid: item_.total_paid,
          text_amount: item_.text_amount
        });

        this.section_flights = data.section_flights;

        this.selectedClientSearch(item_.client_data);
        if (item_.employee_id != null) {
          this.selectedEmployeeSearch(item_.employee_data);
        }
      }
    });
  }

  generateCalendarDateArrival() {
    let component_ = this.thisComponent;
    let mindate: any = null;
    if (this.item.value.date_arrival == null) {
      mindate = new Date();
    }
    (<any>$('#date_arrival')).daterangepicker(
      {
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        minDate: mindate,
        locale: {
          format: 'YYYY-MM-DD'
        }
      },
      function(chosen_date: any) {
        (<any>$('#date_arrival')).val(chosen_date.format('YYYY-MM-DD'));
        component_.setDateArrival(chosen_date.format('YYYY-MM-DD'));
      }
    );

    (<any>$('#date_departure')).daterangepicker(
      {
        singleDatePicker: true,
        autoUpdateInput: false,
        showDropdowns: true,
        autoApply: true,
        minDate: mindate,
        locale: {
          format: 'YYYY-MM-DD'
        }
      },
      function(chosen_date: any) {
        (<any>$('#date_departure')).val(chosen_date.format('YYYY-MM-DD'));
        component_.setDateDeparture(chosen_date.format('YYYY-MM-DD'));
      }
    );
  }

  setDateArrival(date_assigned: any) {
    this.item.patchValue({
      date_arrival: date_assigned
    });
  }

  setDateDeparture(date_assigned: any) {
    this.item.patchValue({
      date_departure: date_assigned
    });
  }

  ngAfterViewInit(): void {
    this.SearchClientComponent.focused();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  // FUNCTIONS LOADS DATAS

  getAirlines() {
    this.airlineService.all().subscribe({
      next: (data: any) => {
        this.airlines = data.results;
      }
    });
  }

  getOriginBooking() {
    this.generalService.listOriginBooking().subscribe({
      next: (data: any) => {
        this.originsbooking = data;
      }
    });
  }

  selectedClientSearch(item_: any) {
    this.isClientSelected = true;
    this.clientSelected = item_;
    this.item.patchValue({
      client_id: item_.id,
      tel_1: item_.cellphone,
      tel_2: item_.telephone
    });
  }

  removeClient() {
    this.isClientSelected = false;
    this.clientSelected = {};
    this.item.patchValue({
      client_id: null
    });
    setTimeout(() => {
      this.SearchClientComponent.focused();
    }, 150);
  }

  extendsClient(event: any): void {
    this.selectedClientSearch(event);
  }

  selectedEmployeeSearch(item_: any) {
    this.employeeSelected = item_;
    this.item.patchValue({
      employee_id: item_.id
    });
  }

  removeEmployee() {
    this.employeeSelected = null;
    this.item.patchValue({
      employee_id: null
    });
    setTimeout(() => {
      this.SearchEmployeeComponent.focused();
    }, 150);
  }

  onFileSelectedFlight(event: any): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      if (this.validateSizeImg(file)) {
        this.selectedPdfFileFlight = file;
      }
    } else {
      this.selectedPdfFileFlight = null;
      (<any>$('#file_pdf')).val(null);
      // alert('Por favor, seleccione un archivo PDF.');
      this.alert.warning('Por favor, seleccione un archivo PDF.');
    }
  }

  validateSizeImg(file: any, isMulti: boolean = false) {
    const maxSize = 1024 * 1024; // 1MB in bytes
    if (file) {
      if (file.size / maxSize > environment.max_size_file) {
        let _txt = 'El tamaño del archivo seleccionado (' + file.name + ')';
        this.alertifyMsg.warning(
          _txt +
            ' excede el límite permitido (1 MB). Elija un archivo más pequeño; ó reduzca el tamaño del archivo.',
          10
        );
        return false;
      }
    }

    return true;
  }

  removeFilePdfFlight() {
    this.item.patchValue({
      url_file_flight: null
    });
  }

  //  add section flights

  changeAirline() {
    this.airlineSelectedData = null;
    if (this.airlineSelected != null) {
      this.airlineSelectedData = this.toolsService.searchObjById(
        this.airlineSelected,
        this.airlines
      );
    }
  }

  addSectionFlight() {
    let obj_: any = {};
    obj_.id = null;
    obj_.flights_id = null;
    if (this.validateSectionFlight()) {
      obj_.tourismairlines = this.airlineSelectedData;
      obj_.tourismairlines_id = this.airlineSelected;
      // data departure airport
      obj_.departure_airport = this.airportDeparture;
      obj_.departure_airport_id = this.airportDeparture.id;
      obj_.date_departure = this.dateDeparture;
      obj_.time_departure = this.timeDeparture;
      // data arrival airport
      obj_.arrival_airport = this.airportArrival;
      obj_.arrival_airport_id = this.airportArrival.id;
      obj_.date_arrival = this.dateArrival;
      obj_.time_arrival = this.timeArrival;
      // data otros datos
      obj_.number_flight = this.number_flight;
      this.section_flights.push(obj_);
      this.clearDataSectionFlight();
    }
  }

  removeSectionFlight(id: any, index: any) {
    this.section_flights.splice(index, 1);
  }

  clearDataSectionFlight() {
    this.airportDeparture = null;
    this.dateDeparture = null;
    this.timeDeparture = null;
    this.airportArrival = null;
    this.dateArrival = null;
    this.timeArrival = null;
    this.airlineSelected = null;
    this.number_flight = null;
  }

  validateSectionFlight() {
    if (this.airportDeparture == null) {
      this.alertifyMsg.warning('Debe seleccionar el aeropuerto de salida');
      return false;
    }

    if (!this.dateDeparture) {
      this.alertifyMsg.warning('Debe especificar la FECHA de salida');
      (<any>$('#date_departure')).focus();
      return false;
    }

    if (!this.timeDeparture) {
      this.alertifyMsg.warning('Debe especificar la HORA de salida');
      (<any>$('#time_departure')).focus();
      return false;
    }

    if (this.airportArrival == null) {
      this.alertifyMsg.warning('Debe seleccionar el aeropuerto de llegada');
      return false;
    }

    if (!this.dateArrival) {
      this.alertifyMsg.warning('Debe especificar la FECHA de llegada');
      (<any>$('#date_arrival')).focus();
      return false;
    }

    if (!this.timeArrival) {
      this.alertifyMsg.warning('Debe especificar la HORA de llegada');
      (<any>$('#time_arrival')).focus();
      return false;
    }

    if (this.airlineSelected == null) {
      this.alertifyMsg.warning('Debe seleccionar la AEROLÍNEA');
      return false;
    }

    return true;
  }

  selectedAirportDeparture(item_: any) {
    this.airportDeparture = item_;
  }

  removeAirportDeparture() {
    this.airportDeparture = null;
  }

  selectedAirportArrival(item_: any) {
    this.airportArrival = item_;
  }

  removeAirportArrival() {
    this.airportArrival = null;
  }

  onSubmit() {
    this.submitted = true;
    if (_.isEmpty(this.item.value.date_arrival)) {
      this.item.patchValue({
        date_arrival: null
      });
    }
    if (_.isEmpty(this.item.value.time_arrival)) {
      this.item.patchValue({
        time_arrival: null
      });
    }

    if (this.item.invalid) {
      return;
    }
    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;

      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('item', JSON.stringify(data));
      formData.append('section_flights', JSON.stringify(this.section_flights));
      formData.append('url_file_flight', this.selectedPdfFileFlight);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.bookingflights.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.router.navigate([
              this.branchofficeSlug + '/pasajes/tickets/detalle',
              this.checkId
            ]);
            // this.editData();
          }
        });
      } else {
        this.bookingflights.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.router.navigate([
              this.branchofficeSlug + '/pasajes/tickets/detalle',
              data.data.id
            ]);
          }
        });
      }
    }
  }

  validate() {
    let obj_ = this.item.value;
    if (_.isNull(obj_.client_id)) {
      this.alertifyMsg.warning('Debe seleccionar el cliente responsable');
      this.SearchClientComponent.focused();
      return false;
    }

    if (this.isEdit) {
      if (Number(obj_.total) < Number(obj_.total_paid)) {
        console.log('si entra');
        let options = {
          title: '¡Atención!',
          message: 'El total de la reserva NO PUEDE SER MENOR al monto pagado'
        };
        this.alert.warning(options);
        (<any>$('#total_tours')).focus();
        return false;
      }
    }

    return true;
  }

  toggleDiv() {
    this.showSectionFlight = !this.showSectionFlight;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/pasajes/tickets/lista']);
  }
}
